import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import HeroBanner from "../components/home/HeroBanner";
import LimitedCollections from "../components/home/LimitedCollections";
import HomeVideo from "../components/home/HomeVideo";
import FindPerfectMatch from "../components/home/FindPerfectMatch";
import ShopByCategories from "../components/home/ShopByCategories";
import ExclusiveCollection from "../components/home/ExclusiveCollection";
import ChooseYourLook from "../components/home/ChooseYourLook";
import ShopByOccasion from "../components/home/ShopByOccasion";
import PromoPopup from "../components/home/PromoPopup";
import About from "../components/About";
import WhyUs from "../components/WhyUs";
import Collections from "../components/Collections";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";
import useReveal from "../hooks/useReveal";

export default function Home() {
  useReveal();
  const location = useLocation();

  // Scroll to a section when the URL carries a hash (e.g. /#collections).
  // Small timeout gives the DOM a beat to render the target section.
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    const el = document.getElementById(id);
    if (el) {
      setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 120);
    }
  }, [location]);

  return (
    <div className="alankar-site tk-site">
      <Header />
      <main>
        <HeroBanner />
        <LimitedCollections />
        <FindPerfectMatch />
        <ShopByCategories />
        <HomeVideo />
        <ChooseYourLook />
        <ExclusiveCollection />
        <ShopByOccasion />
        <Collections />
        <WhyUs />
        <About />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <PromoPopup />
    </div>
  );
}
